<h1 class="title is-1">{{ title }}</h1>

<div class="actions buttons has-addons">
    <ng-content></ng-content>
</div>
